// extracted by mini-css-extract-plugin
module.exports = {"one":"GoogleOneTap_one__uR_dP"};